import { startOfISOWeek } from 'date-fns';

/**
 * The portal Weekly Recap modal opens at most once per ISO week per user.
 * Dismissal is tracked in localStorage under a key scoped to the ISO-week
 * starting Monday UTC. Aligned with the BE `weekStart`/`weekEnd` boundary
 * in `TeamPortalService.composeDashboard`.
 */
const KEY_PREFIX = 'hf-portal:weekly-recap-dismissed:';

function currentWeekKey(): string {
  return KEY_PREFIX + startOfISOWeek(new Date()).toISOString().slice(0, 10);
}

export function isWeeklyRecapDismissed(): boolean {
  if (typeof window === 'undefined') return false;
  return !!window.localStorage.getItem(currentWeekKey());
}

export function dismissWeeklyRecap(): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(currentWeekKey(), '1');
}
